import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  Box,
  Link,
  Drawer,
  Typography,
  Avatar,
  Divider,
  IconButton,
  Badge,
} from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Scrollbar from "../../components/Scrollbar";
import NavSection from "../../components/NavSection";
import sidebarConfig from "../../config/sidebarConfig";
import Logo from "../../components/common/Logo";
import { getUser } from "../../services/authService";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import UploadAvatar from "../../components/UploadAvatar";
import config from "../../config/envConfig";

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  drawerWidth: PropTypes.number,
  handleClose: PropTypes.func,
};

export default function DashboardSidebar({
  isOpenSidebar,
  onCloseSidebar,
  drawerWidth,
  handleClose,
}) {
  const RootStyle = styled("div")(({ theme }) => ({
    [theme.breakpoints.up("lg")]: {
      flexShrink: 0,
      width: drawerWidth,
      position: "relative",
    },
  }));

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const AccountStyle = styled("div")(({ theme }) => ({
    alignItems: "center",
    padding: theme.spacing(1, 1.5),
    borderRadius: Number(theme.shape.borderRadius) * 1,
    backgroundColor: theme.palette.grey[100],
  }));
  const { pathname } = useLocation();
  const user = getUser();

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <>
      <Scrollbar
        sx={{
          height: 1,
          "& .simplebar-content": {
            height: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden !important",
          },
        }}
      >
        <UploadAvatar open={open} onClose={closeDialog} />

       <Box sx={{ 
  px: 1, 
  py: 3, 
  display: "flex",         
  justifyContent: "center", 
  alignItems: "center"     
}}>
  <Logo height={70} width={200} />
</Box>


        <Box sx={{ mb: 1, mx: 1.5 }}>
          {drawerWidth === 220 && (
            <Link underline="none" component={RouterLink} to="#">
              <AccountStyle>
                {user?.userDetails.CompanyName && (
                  <>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "grey",
                        fontSize: "12px",
                        mb: 1,
                        textAlign: "center",
                      }}
                    >
                      {user?.userDetails.CompanyName}
                    </Typography>
                    <Divider></Divider>
                  </>
                )}
                <Box sx={{ display: "flex" }}>
                  <IconButton onClick={handleClick}>
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      color="info"
                      badgeContent={<CameraAltIcon fontSize="2px" />}
                    >
                      <Avatar
                        src={`${config.adminProfileDocpath}${user?.userDetails.Logo}`}
                        alt="photoURL"
                        sx={{ height: "30px", width: "30px" }}
                      />
                    </Badge>
                  </IconButton>
                  <Box sx={{ ml: 2, mt: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.primary", p: 0, fontSize: "12px" }}
                    >
                      {user?.getUserFullName()}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        p: 0,
                        pl: 0,
                        fontSize: "11px",
                      }}
                    >
                      {user?.designation}
                    </Typography>
                  </Box>
                </Box>
              </AccountStyle>
            </Link>
          )}
        </Box>

        <NavSection navConfig={sidebarConfig} onCloseSidebar={onCloseSidebar} />

        <Box sx={{ flexGrow: 1 }} />
      </Scrollbar>
    </>
  );

  return (
    <RootStyle>
      <IconButton
        aria-label="delete"
        component="span"
        sx={{
          position: "absolute",
          right: -10,
          zIndex: 1201,
          top: 10,
          background: "#ffffff !important",
        }}
        size="small"
        onClick={onCloseSidebar}
      >
        {drawerWidth === 55 ? (
          <KeyboardArrowRight fontSize="inherit" />
        ) : (
          <KeyboardArrowLeft fontSize="inherit" />
        )}
      </IconButton>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={handleClose}
          PaperProps={{
            sx: { width: drawerWidth },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open={!isOpenSidebar}
          variant="persistent"
          onClose={onCloseSidebar}
          PaperProps={{
            sx: {
              width: drawerWidth,
              bgcolor: "background.paper",
              borderRightStyle: "none",
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
